module.exports = __webpack_public_path__ + "static/media/logo-rambody-white.818c0b64.png";